import React, { useState } from "react";
import { endpoints } from "../api";
import { useNavigate } from "react-router-dom";

const CampaignWizard = () => {
  //  schedule
  const [scheduleType, setScheduleType] = useState("now");
  const [scheduleDate, setScheduleDate] = useState("");

  const [fileName, setFileName] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const [step, setStep] = useState(1);
  const navigate = useNavigate();

  // 1. Get user data from localstore
  const user = localStorage.getItem("user_email");
  const brand = localStorage.getItem("user_company") || "TSP"; // Fallback to TSP if empty
  const industry = localStorage.getItem("user_industry") || "fashion"; // Fallback to fashion if empty

  const [formData, setFormData] = useState({
    campaign_name: "",
    goal: "abandoned carts",
    tone: "Helpful",
    follow_up_count: 4,
  });

  const saveP1 = async () => {
    try {
      await endpoints.savePage1({
        user_email: user,
        brand: brand, // Pulled from localstore
        industry: industry, // Pulled from localstore
        prompt: "Write reminder",
        ...formData,
      });
      localStorage.setItem("active_campaign", formData.campaign_name);
      setStep(2);
    } catch (e) {
      alert("Error saving campaign");
    }
  };

  // ... rest of your component logic

  // Dropdown Arrays
  const goals = [
    "abandoned carts",
    "welcome series",
    "re-engagement",
    "product launch",
  ];
  const tones = ["Helpful", "Professional", "Friendly", "Urgent", "Casual"];

  // 2. Modified Upload Function
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name); // Store the name to show the user
    }
  };

  // 1. Add these new states to your component
  const [generatedContent, setGeneratedContent] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null); // stores index
  const [selectedBody, setSelectedBody] = useState(null); // stores index

  // 2. Update the proceedToStep3 function to save the response
  const proceedToStep3 = async () => {
    const fileInput = document.getElementById("csv-upload");
    if (!fileInput.files[0]) return alert("Please select a file first");

    setIsUploading(true);
    const fd = new FormData();
    fd.append("file", fileInput.files[0]);
    fd.append("user_email", user);
    fd.append("campaign_name", formData.campaign_name);

    try {
      await endpoints.uploadCSV(fd);
      const res = await endpoints.generate({
        user_email: user,
        campaign_name: formData.campaign_name,
      });

      // Save the API response (subject_lines and email_bodies)
      setGeneratedContent(res.data);
      setEditedContent(res.data);
      setStep(3);
    } catch (error) {
      alert("Generation failed");
    } finally {
      setIsUploading(false);
    }
  };

  // 3. Final Selection API call
  const [editedContent, setEditedContent] = useState(generatedContent); // Local copy for editing
const [isEditingSubject, setIsEditingSubject] = useState(null); // Tracks which subject index is being edited
const [isEditingBody, setIsEditingBody] = useState(null); // Tracks which body index is being edited

const handleFinalSubmit = async () => {
  try {
    await endpoints.selectVersion({
      user_email: user,
      campaign_name: formData.campaign_name,
      subject_index: selectedSubject,
      body_index: selectedBody,
      // NEW: Sending the actual text from our edited state
      subject: editedContent.subject_lines[selectedSubject],
      body: editedContent.email_bodies[selectedBody],
    });
    setStep(4);
  } catch (e) {
    alert("Selection failed");
  }
};

  const handleSaveSchedule = async () => {
    try {
      await endpoints.saveSchedule({
        user_email: user,
        campaign_name: formData.campaign_name,
        schedule_type: scheduleType,
        scheduled_date: scheduleDate, // This will be sent if type is 'scheduled'
      });
      navigate("/tracker");
    } catch (e) {
      alert("Schedule failed");
    }
  };

  //   const handleSelection = async (idx) => {
  //     try {
  //       await endpoints.selectVersion({
  //         user_email: user,
  //         campaign_name: formData.campaign_name,
  //         subject_index: idx,
  //         body_index: idx,
  //       });
  //       navigate("/schedule");
  //     } catch (e) {
  //       alert("Selection failed");
  //     }
  //   };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-start" }}>
        <div
            className="auth-card"
            style={{
              width: "100%",
              maxWidth: step === 3 ? "800px" : "450px",
              transition: "max-width 0.3s ease",
            }}
          >
            <h2 style={{ textAlign: "center" }}>Campaign Wizard</h2>
            <p className="subtitle" style={{ textAlign: "center" }}>
              Step {step} of 4
            </p>

            {step === 1 && (
              <div className="input-group">
                <label>Campaign Name</label>
                <input
                  placeholder="e.g. Fashion Blast"
                  onChange={(e) =>
                    setFormData({ ...formData, campaign_name: e.target.value })
                  }
                />

                <label style={{ marginTop: "15px" }}>Campaign Goal</label>
                <input
                  type="text"
                  placeholder={goals.join(", ")}
                  onChange={(e) => setFormData({ ...formData, goal: e.target.value })}
                />

                <label style={{ marginTop: "15px" }}>Email Tone</label>
                <select
                  style={selectStyle}
                  onChange={(e) =>
                    setFormData({ ...formData, tone: e.target.value })
                  }
                >
                  {tones.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </select>

                <label style={{ marginTop: "15px" }}>
                  Follow-up Count (1-5)
                </label>
                <input
                  type="number"
                  min="1"
                  max="5"
                  value={formData.follow_up_count}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      follow_up_count: parseInt(e.target.value),
                    })
                  }
                />

                <button
                  className="btn-primary"
                  onClick={saveP1}
                  style={{ marginTop: "25px" }}
                >
                  Next Step
                </button>
              </div>
            )}

            {step === 2 && (
              <div className="input-group">
                <label>Upload Contact List</label>
                <div
                  style={{
                    border: "2px dashed var(--border)",
                    borderRadius: "12px",
                    padding: "30px 20px",
                    textAlign: "center",
                    background: "var(--input)",
                    cursor: "pointer",
                    marginTop: "10px",
                  }}
                  onClick={() => document.getElementById("csv-upload").click()}
                >
                  <div style={{ fontSize: "24px" }}>
                    {fileName ? "📄" : "📁"}
                  </div>
                  <div
                    style={{
                      fontWeight: "600",
                      color: "var(--text)",
                      marginTop: "10px",
                    }}
                  >
                    {fileName ? fileName : "Click to select CSV"}
                  </div>
                  {fileName && (
                    <div
                      style={{
                        fontSize: "12px",
                        color: "var(--accent)",
                        marginTop: "5px",
                      }}
                    >
                      File selected successfully
                    </div>
                  )}

                  <input
                    id="csv-upload"
                    type="file"
                    accept=".csv"
                    style={{ display: "none" }}
                    onChange={handleFileUpload}
                  />
                </div>

                {fileName && (
                  <button
                    className="btn-primary"
                    onClick={proceedToStep3}
                    disabled={isUploading}
                    style={{ marginTop: "20px" }}
                  >
                    {isUploading
                      ? "Uploading & Generating..."
                      : "Proceed to Selection"}
                  </button>
                )}

                <button
                  className="footer-link"
                  style={{
                    background: "none",
                    border: "none",
                    width: "100%",
                    marginTop: "10px",
                  }}
                  onClick={() => setStep(1)}
                >
                  ← Back
                </button>
              </div>
            )}

            {step === 3 && generatedContent && (
  <div style={{ width: "100%" }}>
    <h2 style={{ textAlign: "center", fontSize: "24px", marginBottom: "10px" }}>Select & Edit Content</h2>
    
    <div style={{ maxHeight: "65vh", overflowY: "auto", paddingRight: "15px" }}>
      
      {/* SUBJECTS SECTION */}
      <div style={{ marginBottom: "35px" }}>
        <label style={{ color: "var(--accent)", fontWeight: "bold", display: "block", marginBottom: "12px" }}>
          Step A: Choose & Edit Subject Line
        </label>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {editedContent.subject_lines?.map((line, idx) => (
            <div key={idx} 
                 onClick={() => setSelectedSubject(idx)}
                 style={{
                    padding: "15px", border: "1px solid", borderRadius: "10px", cursor: "pointer",
                    borderColor: selectedSubject === idx ? "var(--accent)" : "var(--border)",
                    background: selectedSubject === idx ? "rgba(59, 130, 246, 0.15)" : "var(--input)",
                    position: "relative"
                 }}>
              
              {isEditingSubject === idx ? (
                <input 
                  autoFocus
                  style={{ width: "90%", background: "transparent", color: "white", border: "none", outline: "none", fontSize: "15px" }}
                  value={line}
                  onChange={(e) => {
                    const newLines = [...editedContent.subject_lines];
                    newLines[idx] = e.target.value;
                    setEditedContent({...editedContent, subject_lines: newLines});
                  }}
                  onBlur={() => setIsEditingSubject(null)}
                />
              ) : (
                <span style={{ color: selectedSubject === idx ? "white" : "var(--text-dim)" }}>{line}</span>
              )}

              <span 
                onClick={(e) => { e.stopPropagation(); setIsEditingSubject(idx); }}
                style={{ position: "absolute", right: "15px", cursor: "pointer", opacity: 0.7 }}>
                ✏️
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* BODIES SECTION */}
      <div>
        <label style={{ color: "var(--accent)", fontWeight: "bold", display: "block", marginBottom: "12px" }}>
          Step B: Choose & Edit Email Body
        </label>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {editedContent.email_bodies?.map((body, idx) => (
            <div key={idx}
                 onClick={() => setSelectedBody(idx)}
                 style={{
                    padding: "20px", border: "1px solid", borderRadius: "10px", cursor: "pointer",
                    borderColor: selectedBody === idx ? "var(--accent)" : "var(--border)",
                    background: selectedBody === idx ? "rgba(59, 130, 246, 0.15)" : "var(--input)",
                    position: "relative"
                 }}>
              
              {isEditingBody === idx ? (
                <textarea 
                  autoFocus
                  rows={6}
                  style={{ width: "100%", background: "transparent", color: "white", border: "none", outline: "none", fontSize: "14px", lineHeight: "1.7", resize: "vertical" }}
                  value={body}
                  onChange={(e) => {
                    const newBodies = [...editedContent.email_bodies];
                    newBodies[idx] = e.target.value;
                    setEditedContent({...editedContent, email_bodies: newBodies});
                  }}
                  onBlur={() => setIsEditingBody(null)}
                />
              ) : (
                <div style={{ color: selectedBody === idx ? "white" : "var(--text-dim)", whiteSpace: "pre-line", fontSize: "14px", lineHeight: "1.7" }}>
                  {body}
                </div>
              )}

              <span 
                onClick={(e) => { e.stopPropagation(); setIsEditingBody(idx); }}
                style={{ position: "absolute", top: "15px", right: "15px", cursor: "pointer", opacity: 0.7 }}>
                ✏️
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>

    <button
      className="btn-primary"
      disabled={selectedSubject === null || selectedBody === null}
      onClick={handleFinalSubmit}
      style={{ marginTop: "30px", height: "50px", width: "100%", opacity: (selectedSubject === null || selectedBody === null) ? 0.5 : 1 }}
    >
      Confirm & Schedule Campaign
    </button>
  </div>
)}

            {step === 4 && (
    <div className="input-group" style={{ width: '100%', maxWidth: '450px', margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center' }}>Final Step: Schedule</h2>
        <p className="subtitle" style={{ textAlign: 'center' }}>When should we start sending these emails?</p>

        <div style={{ marginTop: '30px' }}>
            <label style={{ color: 'var(--accent)', fontWeight: 'bold', fontSize: '13px' }}>Select Timing</label>
            <select 
                style={{ ...selectStyle, marginTop: '10px' }} 
                onChange={e => setScheduleType(e.target.value)}
                value={scheduleType}
            >
                <option value="now">Send Now</option>
                <option value="scheduled">Schedule for Later</option>
            </select>
        </div>

        {scheduleType === "scheduled" && (
            <div style={{ marginTop: '20px' }}>
                <label style={{ color: 'var(--accent)', fontWeight: 'bold', fontSize: '13px' }}>Date & Time (YYYY-MM-DD HH:MM:SS)</label>
                <input 
                    type="datetime-local" 
                    step="1" // Enables seconds in the browser picker
                    onChange={e => {
                        // Converts "YYYY-MM-DDTHH:MM" to "YYYY-MM-DD HH:MM:SS"
                        const val = e.target.value.replace('T', ' ');
                        const formatted = val.length === 16 ? `${val}:00` : val; 
                        setScheduleDate(formatted);
                    }}
                    style={{
                        ...selectStyle,
                        marginTop: '10px',
                        colorScheme: 'dark', 
                        padding: '10px'
                    }}
                />
                {scheduleDate && (
                    <p style={{ fontSize: '11px', color: 'var(--text-dim)', marginTop: '8px' }}>
                        Selected: <span style={{ color: 'var(--accent)' }}>{scheduleDate}</span>
                    </p>
                )}
            </div>
        )}

        <button 
            className="btn-primary" 
            onClick={handleSaveSchedule}
            style={{ marginTop: '40px' }}
        >
            🚀 Launch Campaign
        </button>
        
        <p 
            className="footer-link" 
            style={{ textAlign: 'center', cursor: 'pointer', marginTop: '20px' }}
            onClick={() => setStep(3)}
        >
            ← Back to Selection
        </p>
    </div>
)}
          </div>
        {/* </main> */}
      </div>
    // </div>
  );
};


const selectStyle = {
  width: "100%",
  padding: "12px",
  background: "var(--input)",
  border: "1px solid var(--border)",
  borderRadius: "8px",
  color: "white",
  cursor: "pointer",
};

export default CampaignWizard;
